// Product Card Variant Image Hover
if (typeof ProductCardVariantHover === 'undefined') {
class ProductCardVariantHover {
  constructor() {
    this.originalImages = new WeakMap();
    this.init();
  }

  init() {
    // Use event delegation for dynamic content support
    this.setupEventDelegation();

    // Also run on DOMContentLoaded to store original images
    document.addEventListener("DOMContentLoaded", () => {
      this.storeOriginalImages();
    });
  }

  setupEventDelegation() {
    // Use event delegation on document for mouseenter
    document.addEventListener(
      "mouseenter",
      (e) => {
        // Check if e.target is an Element node before calling closest
        if (!(e.target instanceof Element)) return;

        // Portal tooltip to body to escape overflow:hidden AND transform parents
        const tooltipHost = e.target.closest(
          ".product-card .swatch-item[data-tooltip], .product-card .product-card__option-button[data-tooltip]"
        );
        if (tooltipHost) {
          this.showSharedTooltip(tooltipHost);
        }

        const target = e.target.closest(
          ".product-card__option-button[data-variant-image], .swatch-item[data-variant-image]"
        );
        if (!target) return;

        this.handleMouseEnter(target);
      },
      true
    );

    // Use event delegation on document for mouseleave
    document.addEventListener(
      "mouseleave",
      (e) => {
        // Check if e.target is an Element node before calling closest
        if (!(e.target instanceof Element)) return;

        const tooltipHost = e.target.closest(
          ".product-card .swatch-item[data-tooltip], .product-card .product-card__option-button[data-tooltip]"
        );
        if (tooltipHost) {
          this.hideSharedTooltip();
        }

        const target = e.target.closest(
          ".product-card__option-button[data-variant-image], .swatch-item[data-variant-image]"
        );
        if (!target) return;

        this.handleMouseLeave(target);
      },
      true
    );

    // Prevent redirect on click for option buttons and color swatches
    document.addEventListener(
      "click",
      (e) => {
        if (!(e.target instanceof Element)) return;

        const target = e.target.closest(
          ".product-card__option-button, .swatch-item[data-variant-image] a"
        );
        if (!target) return;

        e.preventDefault();

        // Find the actual element (swatch-item or option-button)
        const actualTarget = target.classList.contains(
          "product-card__option-button"
        )
          ? target
          : target.closest(".swatch-item");

        if (actualTarget) {
          this.handleClick(actualTarget);
        }
      },
      true
    );
  }

  storeOriginalImages() {
    const productCards = document.querySelectorAll(".product-card");
    productCards.forEach((card) => {
      const mainImage = card.querySelector(".product-card__image--main img");
      if (mainImage && !mainImage.dataset.originalSrc) {
        mainImage.dataset.originalSrc = mainImage.src;
        mainImage.dataset.originalSrcset = mainImage.srcset || "";
      }
    });
  }

  handleMouseEnter(element) {
    const productCard = element.closest(".product-card");
    if (!productCard) return;

    const mainImage = productCard.querySelector(
      ".product-card__image--main img"
    );
    if (!mainImage) return;

    // Store original image if not already stored
    if (!mainImage.dataset.originalSrc) {
      mainImage.dataset.originalSrc = mainImage.src;
      mainImage.dataset.originalSrcset = mainImage.srcset || "";
    }

    // Change to variant image
    const variantImageUrl = element.dataset.variantImage;
    if (variantImageUrl) {
      mainImage.src = variantImageUrl;
      // Update srcset for responsive images
      const srcsetPattern = variantImageUrl.split("?")[0];
      mainImage.srcset = this.generateSrcset(srcsetPattern);
    }

    // Update selected state for both option buttons and color swatches (persist on hover)
    const optionsContainer = element.closest(".product-card__options");
    const swatchesContainer = element.closest(".product-card__swatches");

    if (
      optionsContainer &&
      element.classList.contains("product-card__option-button")
    ) {
      // Remove selected state from all buttons
      optionsContainer
        .querySelectorAll(".product-card__option-button")
        .forEach((btn) => {
          btn.removeAttribute("aria-selected");
          btn.style.borderColor = "#e0e0e0";
          btn.style.backgroundColor = "#ffffff";
        });

      // Add selected state to current button
      element.setAttribute("aria-selected", "true");
      element.style.borderColor = "#000";
      element.style.backgroundColor = "#ffffff";

      // Store the new image as the "original" so it doesn't revert on mouseleave
      if (mainImage) {
        mainImage.dataset.originalSrc = mainImage.src;
        mainImage.dataset.originalSrcset = mainImage.srcset || "";
      }
    } else if (swatchesContainer && element.classList.contains("swatch-item")) {
      // Remove selected state from all swatches
      swatchesContainer.querySelectorAll(".swatch-item").forEach((swatch) => {
        swatch.removeAttribute("aria-selected");
        const swatchColor = swatch.querySelector(".swatch-color");
        if (swatchColor) {
          swatchColor.style.outline = "";
          swatchColor.style.outlineOffset = "";
        }
      });

      // Add selected state to current swatch
      element.setAttribute("aria-selected", "true");
      const swatchColor = element.querySelector(".swatch-color");
      if (swatchColor) {
        // swatchColor.style.outline = '2px solid #000';
        // swatchColor.style.outlineOffset = "2px";
      }

      // Store the new image as the "original" so it doesn't revert on mouseleave
      if (mainImage) {
        mainImage.dataset.originalSrc = mainImage.src;
        mainImage.dataset.originalSrcset = mainImage.srcset || "";
      }
    }
  }

  handleMouseLeave(element) {
    // Both option buttons and swatches persist their selection
    // No need to restore images on mouseleave
    return;
  }

  handleClick(element) {
    // Just trigger the same behavior as mouseenter
    // (selection is already handled there)
    this.handleMouseEnter(element);
  }

  generateSrcset(baseUrl) {
    const widths = [70, 140, 165, 355, 450, 535, 710, 900, 1070, 1420];
    return widths
      .map((width) => `${baseUrl}?width=${width} ${width}w`)
      .join(", ");
  }

  getSharedTooltip() {
    if (this.sharedTooltip && this.sharedTooltip.isConnected) {
      return this.sharedTooltip;
    }
    const el = document.createElement("span");
    el.className = "pcard-shared-tooltip";
    // Match theme tooltip visual style (kept in sync with .tooltip CSS)
    el.style.cssText = [
      "position: fixed",
      "z-index: 9999",
      "background-color: rgb(var(--color-foreground))",
      "color: rgb(var(--color-background))",
      "padding: 0.3rem 1rem",
      "border-radius: var(--medium-blocks-radius, 4px)",
      "max-width: 160px",
      "width: max-content",
      "white-space: normal",
      "text-align: center",
      "line-height: 1.3",
      "font-size: calc(var(--font-body-size, 1.4rem) * 0.9)",
      "pointer-events: none",
      "opacity: 0",
      "transform: translate(-50%, 0) scale(0.85)",
      "transform-origin: center",
      "transition: opacity 0.2s ease, transform 0.2s ease",
      "will-change: transform, opacity",
    ].join(";");

    // Label holds the text so the arrow can sit beside it without affecting layout
    const label = document.createElement("span");
    label.className = "pcard-shared-tooltip__label";
    label.style.position = "relative";
    el.appendChild(label);
    this._sharedTooltipLabel = label;

    // Down arrow as child element (CSS ::after not possible via inline style)
    const arrow = document.createElement("span");
    arrow.className = "pcard-shared-tooltip__arrow";
    arrow.style.cssText = [
      "position: absolute",
      "left: 50%",
      "width: 0",
      "height: 0",
      "border-style: solid",
      "transform: translateX(-50%)",
      "pointer-events: none",
    ].join(";");
    el.appendChild(arrow);
    this._sharedTooltipArrow = arrow;

    document.body.appendChild(el);
    this.sharedTooltip = el;
    return el;
  }

  showSharedTooltip(host) {
    const sourceTooltip = host.querySelector(".tooltip");
    if (!sourceTooltip) return;
    const text = (sourceTooltip.textContent || "").trim();
    if (!text) return;

    // Suppress the in-place tooltip so it doesn't render clipped behind the shared one
    if (this._suppressedSource && this._suppressedSource !== sourceTooltip) {
      this._suppressedSource.style.visibility = "";
    }
    sourceTooltip.style.visibility = "hidden";
    this._suppressedSource = sourceTooltip;

    const shared = this.getSharedTooltip();
    this._sharedTooltipLabel.textContent = text;

    const rect = host.getBoundingClientRect();
    const gap = 12;
    const pad = 8;
    const arrowSize = 8;

    // Reset position and transform so offsetWidth/Height give true layout size
    shared.style.opacity = "0";
    shared.style.transform = "none";
    shared.style.insetInlineStart = "0px";
    shared.style.insetBlockEnd = "auto";
    shared.style.insetBlockStart = "0px";

    // Use offsetWidth/Height to ignore any transform scale in measurement
    const tooltipWidth = shared.offsetWidth;
    const tooltipHeight = shared.offsetHeight;
    const halfW = tooltipWidth / 2;

    // Clamp horizontal center within viewport
    const swatchCenterX = rect.left + rect.width / 2;
    let centerX = swatchCenterX;
    const minCenter = pad + halfW;
    const maxCenter = window.innerWidth - pad - halfW;
    if (centerX < minCenter) centerX = minCenter;
    if (centerX > maxCenter) centerX = maxCenter;

    // Place above the host; if no room, flip below
    const flipBelow = rect.top - tooltipHeight - gap < pad;
    const top = flipBelow ? rect.bottom + gap : rect.top - tooltipHeight - gap;

    shared.style.insetInlineStart = `${centerX}px`;
    shared.style.insetBlockStart = `${top}px`;
    shared.style.insetBlockEnd = "auto";
    shared.style.opacity = "1";
    shared.style.transform = "translate(-50%, 0) scale(1)";

    // Position arrow to point at the swatch center, independent of tooltip clamping
    const arrow = this._sharedTooltipArrow;
    if (arrow) {
      // Arrow X within tooltip: swatch center relative to tooltip left edge
      const tooltipLeftEdge = centerX - halfW;
      let arrowX = swatchCenterX - tooltipLeftEdge;
      // Keep arrow visibly inside the tooltip bounds
      const arrowMin = arrowSize + 4;
      const arrowMax = tooltipWidth - arrowSize - 4;
      if (arrowX < arrowMin) arrowX = arrowMin;
      if (arrowX > arrowMax) arrowX = arrowMax;
      arrow.style.left = `${arrowX}px`;
      arrow.style.transform = "translateX(-50%)";

      if (flipBelow) {
        // Arrow on top of tooltip pointing up
        arrow.style.top = `-${arrowSize - 1}px`;
        arrow.style.bottom = "auto";
        arrow.style.borderWidth = `0 ${arrowSize}px ${arrowSize}px`;
        arrow.style.borderColor =
          "transparent transparent rgb(var(--color-foreground))";
      } else {
        // Arrow on bottom of tooltip pointing down (default)
        arrow.style.bottom = `-${arrowSize - 1}px`;
        arrow.style.top = "auto";
        arrow.style.borderWidth = `${arrowSize}px ${arrowSize}px 0`;
        arrow.style.borderColor =
          "rgb(var(--color-foreground)) transparent transparent";
      }
    }
  }

  hideSharedTooltip() {
    if (this._suppressedSource) {
      this._suppressedSource.style.visibility = "";
      this._suppressedSource = null;
    }
    if (!this.sharedTooltip) return;
    this.sharedTooltip.style.opacity = "0";
    this.sharedTooltip.style.transform = "translate(-50%, 0) scale(0.85)";
  }
}

// Initialize
new ProductCardVariantHover();
}
